import React, { Component } from 'react';

class DocsBackEnd extends Component {
  render() {
    return(
      <>
        <div className="src_files">
          <a href='src/read_snps.py'>read_snps.py</a>
          <a href='src/read_genome.py'>read_genome.py</a>
          <a href='src/read_publications.py'>read_publications.py</a>
        </div>
        <p>
          The API on this website was written in Python.<br/><br/>
          The frontend sends GET requests to the script <code>read_snps.py</code>, which accepts a parameter <code>snps</code> - this parameter is a list of rsid's.<br/><br/>
          The JSON response is a dictionary of data about the requested SNPs, including the chromosome, GRCH37 position, and minor allele frequency.
        </p>
        
        <a href="https://moreygenetics.com/api/read_snps.py?snps=rs2074192,rs2106809,rs4646155,rs4646171&files=ace2_list,ace2_23andMe"
          target="_blank"
          rel="noopener noreferrer"
          style={{"fontWeight":"bold"}}>api/read_snps.py?snps=rs2074192,rs2106809,rs4646155,rs4646171&files=ace2_list,ace2_23andMe</a>
        <pre>
{`{
  "rs2106809": {
    "min": "G",
    "alleles": "A/G",
    "genes": [],
    "pos": "15618061",
    "chr": "X",
    "maf": "0.316291"
  },
  "rs4646155": {
    "min": "T",
    "alleles": "C/T",
    "genes": [],
    "pos": "15597509",
    "chr": "X",
    "maf": "0.061457"
  },
  "rs4646171": {
    "min": "C",
    "alleles": "T/C",
    "genes": [],
    "pos": "15589028",
    "chr": "X",
    "maf": "0.0701987"
  },
  "rs2074192": {
    "min": "T",
    "alleles": "C/T",
    "genes": [],
    "pos": "15582790",
    "chr": "X",
    "maf": "0.363179"
  }
}

`}
        </pre>
        
        <p>
          The script reads text files saved on the server to find the information.  These files were obtained from ensembl's publicly available MySQL database using queries like the one below.
        </p>
        
        <a href="https://moreygenetics.com/src/read_ensembl.py"
          target="_blank"
          rel="noopener noreferrer"
          style={{"fontWeight":"bold"}}>read_ensembl.py</a>
        <pre>
{`db = MySQLdb.connect("ensembldb.ensembl.org", user="anonymous", db="homo_sapiens_variation_99_37", port=3337)
        
snps = ["rs2074192","rs2106809","rs4646155","rs4646171"]     
        
chr_list = [str(x) for x in range(1,23)]
chr_list.append("X")

q = """
  SELECT
    a.name,
    c.name chr,
    b.seq_region_start start,
    b.allele_string,
    a.minor_allele,
    a.minor_allele_freq
  FROM
    variation a,
    variation_feature b,
    seq_region c
  WHERE
    a.name IN ('""" + ("','").join(snps) + """') AND
    a.variation_id = b.variation_id AND
    b.seq_region_id = c.seq_region_id AND
    c.name IN ('""" + ("','").join(chr_list) + """')
"""

c.execute(q)
a = c.fetchall()

`}
        </pre>
        
        <p>The results of the MySQL query are printed in tab-delimited format, and saved on my server as a text file.</p>
  
        <a style={{"fontWeight":"bold"}}>read_ensembl.py</a>
        <pre>
{`for line in a :
  print ("\\t").join([str(x) for x in line])

`}
        </pre>

        <a style={{"fontWeight":"bold"}}>ensembl_mysql_downloads/example.txt</a>
        <pre>
{`rs2074192	X	15582790	C/T	T	0.363179
rs2106809	X	15618061	A/G	G	0.316291
rs4646155	X	15597509	C/T	T	0.061457
rs4646171	X	15589028	T/C	C	0.0701987

`}
        </pre>
        
        <p>
         Files in this format are read line by line to check whether the rsid matches one of the requested snps.<br/><br/>
          The list of requested snps is taken from <code>cgi.FieldStorage</code> and named <code>keys</code>, because these will be the keys of the JSON response's top level dictionary.
        </p>
        
        <a style={{"fontWeight":"bold"}}>read_snps.py</a>
        <pre>
{`f = cgi.FieldStorage()

if "snps" in f :
  keys = f["snps"].value.split(",")

`}
        </pre>
        
        <p>
          The files are read and each line is split.  The script checks whether it is one of the requested snps.<br/><br/>
          If it is, a dictionary is created with the keys <code>chr</code>, <code>pos</code>, <code>alleles</code>, <code>minor</code>, and <code>maf</code>.
        </p>
          
        <a style={{"fontWeight":"bold"}}>read_snps.py</a>
        <pre>
{`  snps = {}

  for line in file :
    a = line.strip().split("\\t")
    if a[0] in keys :
      snps[a[0]] = {
        "chr":a[1],
        "pos":a[2],
        "alleles":a[3],
        "min":a[4],
        "maf":a[5],
        "genes":[]
      }

`}
        </pre>
      
        <p>
          Next, it reads other text files to identify the names and descriptions of any genes having a transcript which contains one of the requested variants.
        </p>
        <a style={{"fontWeight":"bold"}}>read_snps.py</a>
        <pre>
{`    for line in file :
      a = line.split("\\t")
      if a[0] in keys :
        gene = {
          "name":a[1],
          "desc":a[2],
          "ensembl":a[3]
        }
    
        if gene not in snps[a[0]]["genes"] :
          snps[a[0]]["genes"].append(gene)

`}
        </pre>
        <p>
          The finished dictionary is output.
        </p>
        
        <a style={{"fontWeight":"bold"}}>read_snps.py</a>
        <pre>{`print json.dumps(snps)
        `}</pre>

      </>
    )
  }
}

export default DocsBackEnd;